import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Colors, Typography } from '../shared/theme/styles.enum';

export const viewsUseStyles = makeStyles((theme: Theme) =>
  createStyles({
    globalViewContent: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignContent: 'center',
      '@media (max-width:768px)': {
        padding: '0 12px',
      },
    },
    globalSideNavMenuItem: {
      color: Colors.TextGray,
      cursor: 'pointer',
      padding: '14px 16px 14px 22px',
      borderLeft: '3px solid transparent',
      transition: 'all 0.15s ease',
      '&:hover': {
        backgroundColor: 'rgba(63,167,149,0.05)',
        borderLeftColor: 'rgba(63,167,149,0.3)',
      },
    },
    globalSideNavTextItem: {
      fontSize: '1.25rem',
      fontFamily: Typography.FontFamily2,
      fontWeight: 500,
      letterSpacing: '0.01em',
    },
    globalSideNavMenu: {
      textDecoration: 'none'
    },
    globalSideNavMenuActive: {
      borderLeft: '3px solid',
      borderLeftColor: theme.palette.primary.main,
      backgroundColor: 'rgba(63,167,149,0.06)',
    },
  })
);
